function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import InlineFieldGroup from '../InlineFieldGroup/InlineFieldGroup';
import Label from '../Label/Label';
import Checkbox from '../Checkbox/Checkbox';
import guid from '../utils/guid';
import { getClassName } from '../utils/get-class-name';
import TscCheckboxAlignment from '../constants/TscCheckboxAlignment';

var InlineLabeledCheckbox = function InlineLabeledCheckbox(_ref) {
  var _ref$checkboxAlignmen = _ref.checkboxAlignment,
      checkboxAlignment = _ref$checkboxAlignmen === void 0 ? TscCheckboxAlignment.right : _ref$checkboxAlignmen,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$isCentered = _ref.isCentered,
      isCentered = _ref$isCentered === void 0 ? false : _ref$isCentered,
      isChecked = _ref.isChecked,
      labelText = _ref.labelText,
      onClick = _ref.onClick,
      testId = _ref.testId;

  var _React$useState = React.useState(function () {
    return guid.new();
  }),
      _React$useState2 = _slicedToArray(_React$useState, 1),
      checkboxId = _React$useState2[0];

  var checkbox = _jsx(Checkbox, {
    className: getClassName(className, 'checkbox'),
    onClick: onClick,
    isChecked: isChecked,
    sharedId: checkboxId,
    a11Text: "Checkbox for ".concat(labelText),
    disabled: disabled,
    testId: testId
  }, "checkbox-".concat(checkboxId));

  var label = _jsx(Label, {
    className: getClassName(className, 'label'),
    labelText: labelText,
    sharedId: checkboxId,
    disabled: disabled
  }, "checkbox-".concat(checkboxId, "-label"));

  var children = checkboxAlignment === TscCheckboxAlignment.left ? [checkbox, label] : [label, checkbox];
  return _jsx(InlineFieldGroup, {
    className: className,
    isHorizontallyCentered: isCentered,
    children: children
  });
};

export default InlineLabeledCheckbox;